/* eslint-disable no-unused-vars */
/*
  Display List of notifications in top right side of the page, reuses many components.
  One of used components is dashboard notification which for now is used to display:
  - NOTIFICATION_SHARES_TRADES
 */
import { mapActions, mapState } from 'vuex';
import notificationItemSimple from '@/components/notification-items/notification-item-simple/notification-item-simple.vue';
import notificationItemTradeConfirmed from '@/components/notification-items/notification-item-trade-confirmed/notification-item-trade-confirmed.vue';
import notificationItemDashboard from '@/components/notification-items/notifcation-item-dashboard/notification-item-dashboard.vue';
import { NOTIFICATION_SHARES_TRADES_CLOSE_DELAY, NOTIFICATION_TRADE_CONFIRMED, NOTIFICATION_SIMPLE, NOTIFICATION_SHARES_TRADES, NOTIFICATION_TRADE_CONFIRMED_CLOSE_DELAY, NOTIFICATION_TRADER_LEVEL_CHANGED } from '@/services/notifications/proxy';

const ROUTE_PORTFOLIO = 'portfolio';
const ROUTE_MARKET_DETAILS = 'market-details';

export default {
  components: {
    notificationItemDashboard,
    notificationItemSimple,
    notificationItemTradeConfirmed,
  },
  data() {
    return {
      NOTIFICATION_SHARES_TRADES_CLOSE_DELAY,
      NOTIFICATION_TRADE_CONFIRMED_CLOSE_DELAY,
      activeNotification: null,
      currentRoute: this.$router.currentRoute,
    };
  },
  watch: {
    notificationList(value) {
      this.activeNotification = value[value.length - 1];
    },
    $route(to, from) {
      this.currentRoute = to;
      if (from.name !== to.name) {
        this.clear();
      }
    },
  },
  computed: {
    ...mapState('notifications', ['notificationList']),
    notificationsToDisplay() {
      return this.notificationList.filter(this.isNotificationDisplayable);
    },
    shouldDisplayNotifications() {
      return this.notificationsToDisplay.length > 0;
    },
  },
  methods: {
    ...mapActions('notifications', ['clear']),
    onClose() {
      this.clear();
    },
    isNotificationDisplayable(notification) {
      return this.shouldDisplayNotificationSimple(notification) ||
          this.shouldDisplayNotificationTradeConfirmed(notification) ||
          this.shouldDisplayDashboardNotification(notification);
    },
    shouldDisplayNotificationSimple(notification) {
      return notification.type === NOTIFICATION_SIMPLE;
    },
    shouldDisplayNotificationTradeConfirmed(notification) {
      if (this.currentRoute.name === ROUTE_MARKET_DETAILS) {
        return (
          notification.type === NOTIFICATION_TRADE_CONFIRMED &&
          notification.data.MarketId.toString() === this.currentRoute.params.marketId.toString()
        );
      } else if (this.currentRoute.name === ROUTE_PORTFOLIO) {
        return notification.type === NOTIFICATION_TRADE_CONFIRMED;
      }
      return false;
    },
    shouldDisplayDashboardNotification(notification) {
      const types = [
        NOTIFICATION_SHARES_TRADES,
        NOTIFICATION_TRADER_LEVEL_CHANGED,
      ];
      return types.includes(notification.type);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/notification-items/notification-items.js